import { PathnameEnum, styleConstant, UserRoleEnum } from '@constant';
import { Box } from '@mui/material';
import { colorSet } from '@theme';
import { useNavigate } from 'react-router';
import { LogoutPopover, Text } from '..';
import { ProfileCirclePrimaryIcon, RefaLogoIcon } from '@assets/iconComponents';
import { useState } from 'react';
import { useSelector } from '@stores';
import { getEnumKeyByValue } from '@utils';

export const AdminMenuTop = () => {
  const [anchorEl, setAnchorEl] = useState<SVGSVGElement | null>(null);

  const storedAuth = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(PathnameEnum.ADMIN_ROOT);
  };

  const handlePopoverOpen = (event: React.MouseEvent<SVGSVGElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        style={{
          width: '100%',
          height: styleConstant.menuTopHeight,
          borderBottom: `1px solid ${colorSet.gray200}`,
          backgroundColor: colorSet.white,
          padding: '0px 40px',
          display: 'inline-flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'fixed',
          left: 0,
          right: 0,
          top: 0,
          zIndex: styleConstant.zIndexMenuTop
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <RefaLogoIcon onClick={handleLogoClick} style={{ width: 64, height: 20, cursor: 'pointer' }} />
          <Text variant="h2" style={{ marginLeft: 12 }}>
            ADMINISTRATOR
          </Text>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Text variant="body1" marginRight="24px">
            {getEnumKeyByValue(UserRoleEnum, storedAuth.role)} <strong>{storedAuth.name}</strong>님
          </Text>
          <ProfileCirclePrimaryIcon
            onClick={(e) => {
              handlePopoverOpen(e);
            }}
            style={{ cursor: 'pointer' }}
          />
          <LogoutPopover anchorEl={anchorEl} handlePopoverClose={handlePopoverClose} />
        </div>
      </Box>
      <Box style={{ width: '100%', height: styleConstant.menuTopHeight }} />
    </>
  );
};
